import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useState } from 'react';

import {
  useCancelDelivery,
  useDeliveredDelivery,
  useDraftDelivery,
  useNotDeliveredDelivery,
} from 'app/hooks/data/welcomeKit/deliveries/useDeliveries';
import type { Delivery } from 'app/typings/WelcomeKit/deliveries';
import { DeliveryStatus, OrderStatus } from 'app/typings/WelcomeKit/deliveries';

import { QuantityDeliveryModal } from './UpdateDeliveryQuantityModal/UpdateDeliveryQuantityModal';

type Props = {
  delivery: Delivery;
  orderStatus?: OrderStatus;
};

export const DeliveryMenuActions = ({ delivery, orderStatus }: Props) => {
  const { mutate: cancelDelivery } = useCancelDelivery(delivery.id);
  const { mutate: draftDelivery } = useDraftDelivery(delivery.id);
  const { mutate: deliverDelivery } = useDeliveredDelivery(delivery.id);
  const { mutate: notDeliverDelivery } = useNotDeliveredDelivery(delivery.id);

  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  if (
    !orderStatus ||
    orderStatus === OrderStatus.Cancelled ||
    (delivery.status === DeliveryStatus.Cancelled &&
      orderStatus === OrderStatus.Sent)
  ) {
    return <></>;
  }

  const getMenuItems = (): MenuProps['items'] => {
    switch (delivery.status) {
      case DeliveryStatus.Cancelled:
        return [
          {
            key: 'draft',
            label: 'Set as "Draft"',
            onClick: () => draftDelivery(),
          },
        ];
      case DeliveryStatus.Delivered:
        return [
          {
            key: 'not-delivered',
            label: 'Set as "Not delivered"',
            onClick: () => notDeliverDelivery(),
          },
        ];
      case DeliveryStatus.Draft:
        return [
          {
            key: 'edit',
            label: 'Edit quantity',
            onClick: () => setModalOpen(true),
          },
          {
            key: 'cancel',
            label: 'Set as "Cancelled"',
            onClick: () => cancelDelivery(),
          },
        ];
      case DeliveryStatus.NotDelivered:
        return [
          {
            key: 'deliver',
            label: 'Set as "Delivered"',
            onClick: () => deliverDelivery(),
          },
        ];
      default:
        return [];
    }
  };

  return (
    <div className="actions-menu">
      <Dropdown menu={{ items: getMenuItems() }} trigger={['click']}>
        <EllipsisOutlined rotate={90} />
      </Dropdown>
      {delivery.status === DeliveryStatus.Draft && (
        <QuantityDeliveryModal
          deliveryId={delivery.id}
          currentDeliveryQuantity={delivery.quantity}
          hotel={delivery.hotel}
          isOpen={isModalOpen}
          closeModal={() => setModalOpen(false)}
          maxQuantity={delivery.hotel.maxQuantity}
        />
      )}
    </div>
  );
};
